export default {
  data: () => ({
    successObject: undefined
  }),
  methods: {
    handleSuccess: function(success, routeName = null) {
      if (routeName !== null) {
        if (this.$route.name !== routeName) {
          this.$router.push({
            name: routeName,
            params: success.data
          });
        }
      } else {
        if (success && success.data) {
          this.successObject = success.data;
        }
        window.scrollTo(0, 0); // 画面のトップに移動
      }
    }
  }
};
